<template>
    <div>
        <div v-if="!response" class="no-answer">
            <span>
                Not Answered
            </span>
        </div>
        <div v-for="(choice, index) in question.max"
            :key="index"
            :class="['choice select-choice', { selected: response != null && response[choice - 1] }]">
            <span class="text">{{ question.select[choice - 1] }}</span>
        </div>
        <template v-if="response && response.other && Array.isArray(response.other)">
            <div  class="choice select-choice selected"
                v-for="(value, index) in response.other"
                :key="'i' + index">
                {{ value }}
            </div>
        </template>
        
    </div>
</template>

<script>

export default {   
    name: 'box-select-partial',

    props: {
		response: {
			type: Object,
        },
        // Content object for this question
		question: {
			type: Object,
			required: true
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
